import { render, staticRenderFns } from "./CreateAccountV2.vue?vue&type=template&id=2327e422&scoped=true"
import script from "./CreateAccountV2.vue?vue&type=script&lang=js"
export * from "./CreateAccountV2.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountV2.vue?vue&type=style&index=0&id=2327e422&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327e422",
  null
  
)

export default component.exports